import request from '@/utils/request';
import { UUID } from '@/utils';
import { reqCatch } from '@/utils/catch';

// 数据上报
export function report(eventId: string, data: object, headers: object = {}): Promise<any> {
  return reqCatch(() => (
    request({
      url: `/api/v1/report`,
      method: 'post',
      data,
      params: {
        event_id: eventId
      },
      headers
    }, { ignoreError: true })
  ));
}

// 可视化曝光数据上报
export function viewReport(ref: string, uri: string, eventId: string, data: object): Promise<any> {
  const pageReqId = new Date().getTime() + '-' + UUID();
  return request({
    url: `/api/v2/report`,
    method: 'post',
    data,
    params: {
      event_id: eventId
    },
    headers: {
      'page-ref': ref,
      'page-req-id': pageReqId,
      'page-uri': uri
    }
  }, { ignoreError: true });
}
